import React from "react";

const HeroBanner = () => {
  return (
    <section
      className="bg-cover bg-center min-h-[600px] flex items-center"
      style={{
        background: `url('../assets/hero-bg.jpg') no-repeat center center`,
      }}
    >
      <div className="max-w-5xl mx-auto px-6 md:px-12 w-full items-center gap-10 py-10">
        {/* Left Column - Text */}
        <div className="space-y-4">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-10">
            Your One-Stop Shop for Everything!
          </h1>
          <h2 className="text-5xl text-[#82b016] font-semibold">
            Discover Deals, Fashion & More
          </h2>
          <p className="text-white text-lg">
            Explore thousands of top products, unbeatable prices, and fast
            delivery. Shop smarter, live better with ShopMate.
          </p>
          <button className="mt-4 px-6 py-2 text-lg bg-gradient-to-r from-[#82b016] to-green-600 hover:from-[#6fa010] hover:to-green-700 text-white font-bold py-3 rounded-xl shadow-lg transition-all duration-300 transform hover:-translate-y-0.5 hover:shadow-xl">
            Start Shopping
          </button>
        </div>
      </div>
    </section>
  );
};
export default HeroBanner;
